import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { LEGAL_CSV_EXPORT_MAX_ROWS, downloadCsv } from './legal-csv-export';

const maxRowsText: string = new Intl.NumberFormat('en-US').format(LEGAL_CSV_EXPORT_MAX_ROWS);

/** Exports a whole filtered list as CSV, reporting failure and truncation. */
export function LegalCsvExportButton({
    filename,
    buildCsv,
}: {
    readonly filename: string;
    readonly buildCsv: () => Promise<{ csv: string; truncated: boolean }>;
}) {
    const [isExporting, setIsExporting] = useState(false);
    const [message, setMessage] = useState<string | null>(null);
    return (
        <div className="flex flex-col items-end gap-1">
            <Button
                variant="outline"
                disabled={isExporting}
                onClick={() => {
                    setIsExporting(true);
                    setMessage(null);
                    buildCsv()
                        .then(({ csv, truncated }) => {
                            downloadCsv(filename, csv);
                            if (truncated) {
                                setMessage(
                                    `Only the first ${maxRowsText} rows were exported. Narrow the filters to export the rest.`
                                );
                            }
                        })
                        .catch(() => {
                            setMessage('The CSV export failed. Try again.');
                        })
                        .finally(() => {
                            setIsExporting(false);
                        });
                }}
            >
                {isExporting ? 'Exporting...' : 'Export CSV'}
            </Button>
            {message === null ? null : (
                <p role="status" className="text-xs text-gray-600">
                    {message}
                </p>
            )}
        </div>
    );
}
